'use client';
import React, { useEffect, useRef, useState } from 'react';

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setInView(true);},
      { threshold }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, [threshold]);
  return { ref, inView };
}

const teamMembers = [
{
  img: '/assets/images/team-1.png',
  name: 'Direction Générale',
  role: 'Stratégie & Management',
  alt: 'Direction Générale COSA - Stratégie et management'
},
{
  img: '/assets/images/team-2.png',
  name: 'Direction Médicale',
  role: 'Qualité des Soins',
  alt: 'Direction Médicale COSA - Qualité des soins'
},
{
  img: '/assets/images/team-3.png',
  name: 'Pool de Médecins',
  role: 'Généralistes & Spécialistes',
  alt: 'Pool de médecins COSA - Généralistes et spécialistes'
},
{
  img: '/assets/images/team-4.png',
  name: 'Personnel Paramédical',
  role: 'Infirmiers & Techniciens',
  alt: 'Personnel paramédical COSA - Infirmiers et techniciens de laboratoire'
}];


export default function OurTeam() {
  const { ref, inView } = useInView();

  return (
    <div className="our-team">
      <div className="dentaire-container">
        {/* Section Title */}
        <div className="row section-row">
          <div className="col-lg-12">
            <div className="section-title" style={{ textAlign: 'center', marginBottom: 0 }}>
              <h3>notre équipe</h3>
              <h2><span>Une Équipe</span> Médicale Dédiée à Votre Santé</h2>
              <p>Des professionnels de santé qualifiés et en formation continue pour vous offrir les meilleurs soins.</p>
            </div>
          </div>
        </div>

        <div className="row" ref={ref}>
          {teamMembers?.map((member, i) =>
          <div key={member?.name} className="col-lg-3 col-md-6">
              <div
              className="team-member-item"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(30px)',
                transition: `opacity 0.6s ease ${i * 0.25}s, transform 0.6s ease ${i * 0.25}s`
              }}>
              
                <div className="team-image">
                  <figure className="image-anime">
                    <img src={member?.img} alt={member?.alt} />
                  </figure>
                  <div className="team-social-icon">
                    <ul>
                      <li><a href="#" className="social-icon"><i className="fa-brands fa-facebook-f"></i></a></li>
                      <li><a href="#" className="social-icon"><i className="fa-brands fa-youtube"></i></a></li>
                      <li><a href="#" className="social-icon"><i className="fa-brands fa-instagram"></i></a></li>
                      <li><a href="#" className="social-icon"><i className="fa-brands fa-x-twitter"></i></a></li>
                    </ul>
                  </div>
                </div>
                <div className="team-content">
                  <h3>{member?.name}</h3>
                  <p>{member?.role}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Star Icon */}
      <div className="icon-star-image">
        <img src="https://html.awaikenthemes.com/dentaire/images/icon-star.svg" alt="Star decoration" />
      </div>
    </div>);

}